<script setup>
/* Imports */
import { onMounted } from 'vue';

/* Helpers */
import {
  mapGetters,
} from '../helpers/mainHelpers.js';

/* Store - Getters */
const {
  getLocale: locale,
  getProductId: productId,
  getPartNumber: partNumber,
} = mapGetters();

onMounted(() => {
  const event = new CustomEvent('garminProductPageWidgetUpdate', {
    detail: {
      locale: locale.value,
      productId: productId.value,
      partNumber: partNumber.value,
    },
  });

  document.dispatchEvent(event);
});
</script>

<template>
  <div>
    <div id="apacProductPageWidgetWrapper" />
  </div>
</template>
